getTrackHandler